<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="LBLUSEFLAG"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="예방접종 목록"
      tableId="table"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="grid.data"
      :columnSetting="false"
      :isFullScreen="false"
      :usePaging="false"
      :expandAll="true"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLREG" icon="add" @btnClicked="linkClick" v-if="editable" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'gov-schedule-manage',
  data() {
    return {
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'col1',
            field: 'col1',
            label: '접종명',
            align: 'center',
            type: 'link',
            style: 'width: 250px',
            sortable: true,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '접종시기',
            align: 'left',
            sortable: true,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '최근 실시일',
            align: 'center',
            style: 'width: 140px',
            sortable: true,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '실시 주기',
            align: 'center',
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: 'col5',
            field: 'col5',
            label: '다음 예정일',
            align: 'center',
            style: 'width: 140px',
            sortable: true,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        govScheduleTypeCd: null,
        plantCd: null,
        useFlag: 'Y',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        width: '80%',
        top: '10',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.env.gov.mst.list.url;
      this.getList();
    },
    getList() {
      // this.$http.url = this.listUrl;
      // this.$http.type = 'GET';
      // this.$http.param = this.searchParam;
      // this.$http.request((_result) => {
      //   this.grid.data = _result.data;
      // },);
      this.grid.data = [
        {
          plantName: '1사업장',
          col1: '장티푸스',
          col2: '연중',
          col3: '2021-02-01',
          col4: '1년',
          col5: '2022-02-01',
          useFlag: 'Y',
        },
        {
          plantName: '1사업장',
          col1: '신증후군 출혈열',
          col2: '8-9월',
          col3: '2022-08-11',
          col4: '1년',
          col5: '2023-08-11',
          useFlag: 'Y',
        },
        {
          plantName: '1사업장',
          col1: '인플루엔자',
          col2: '10-11월',
          col3: '2022-10-01',
          col4: '1년',
          col5: '2023-10-01',
          useFlag: 'Y',
        },
        {
          plantName: '1사업장',
          col1: '폐렴구균',
          col2: '연중',
          col3: '2022-05-01',
          col4: '1년',
          col5: '2023-05-01',
          useFlag: 'Y',
        },
      ]
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () => import(`${"./testVaccinationDetail.vue"}`);
      this.popupOptions.title = '예방접종 상세';
      this.popupOptions.param = {
        govScheduleMstId: result ? result.govScheduleMstId : '',
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
